import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { gaEvent } from '@domgen/shared/services/ga/ga';
import { usePostHog } from '@posthog/react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useIsTenantFeatureEnabled } from '../../hooks';
import { capturePostHogEvent } from '../../services/posthog/capture';
import { store } from '../../store/store';

const styles = {
  supportBox:
    'flex w-full p-space-400 flex-col items-start rounded-[8px] border border-(--color-card-border-neutral) bg-(--color-bg-main)',
};

type MissingModelOrSerialNumberProps = Partial<{
  regSystemCode: string;
  applianceCategory: string;
  applianceName: string;
  appSessionID: string;
}>;

export const MissingModelOrSerialNumber = ({
  regSystemCode,
  applianceCategory,
  applianceName,
  appSessionID,
}: MissingModelOrSerialNumberProps) => {
  const [showSupportBox, setShowSupportBox] = useState(false);
  const posthog = usePostHog();
  const { t } = useTranslation('modelSerialLanding', {
    keyPrefix: 'missingModelOrSerialNumber',
  });

  const isCallUsSupportDisplayed = useIsTenantFeatureEnabled('callUsSupport');

  const handleSupportBoxToggle = () => {
    setShowSupportBox(!showSupportBox);
    gaEvent({
      event: 'genericGAEvent',
      eventCategory: 'appliance details form USA',
      eventAction: 'No Model/Serial Number',
      eventLabel: 'No Model/Serial CTA Clicked',
      pagename: 'landing',
      category: 'registration-pages',
      type: 'STANDARD',
      regSystemCode,
      applianceCategory,
      applianceName,
      appSessionID,
    });
    capturePostHogEvent(posthog, 'landing-no-model-serial-cta-clicked', store.get());
  };

  const phoneNumber = t('phone');

  return (
    <>
      <div className="text-center -mt-2">
        <TextLink onClick={handleSupportBoxToggle}>{t('textLink')}</TextLink>
      </div>
      {showSupportBox && (
        <div className={styles.supportBox}>
          <p className="text-body">
            {isCallUsSupportDisplayed ? (
              <Trans
                ns="modelSerialLanding"
                i18nKey="missingModelOrSerialNumber.callUs"
                components={{
                  phone: (
                    <a
                      href={`tel:${phoneNumber.replace(/[^\d+]/g, '')}`}
                      className="text-body-link-strong"
                    >
                      {phoneNumber}
                    </a>
                  ),
                }}
              />
            ) : (
              t('productSupport')
            )}
          </p>
        </div>
      )}
    </>
  );
};
